import React from 'react'
import style from "./Header.module.css";

function Header() {
  return (
    <>
      <div className={style.header_wrapper}>
        <img src='images/logo_b.webp' alt='로고' />
      </div>
    </>
  )
}

export default Header